/**
 * 空间 API 的共享契约。
 *
 * RBAC、首页和业务 feature 都依赖这个稳定入口；具体管理页面不再成为
 * shared 层的依赖，避免 shared/auth 反向穿透 features/admin。
 */
import { ApiError, client } from './client';
import { apiPaths } from './paths';
import type { MemberView, SpaceRoleResp, SpaceView } from './types';
import { trackOperation } from '../telemetry/operationLog';

let currentSpaceRequest: Promise<SpaceView> | null = null;

function trackFromError(action: string, resource: string, err: unknown): void {
  trackOperation({
    action,
    resource,
    result: 'failure',
    errorCode: err instanceof ApiError ? err.code : 'UNKNOWN',
  });
}

export const spaceApi = {
  getCurrent: (): Promise<SpaceView> => {
    currentSpaceRequest ??= client.get<SpaceView>(apiPaths.spaces.current).finally(() => {
      currentSpaceRequest = null;
    });
    return currentSpaceRequest;
  },
  leave: async (): Promise<void> => {
    try {
      await client.post<void>(apiPaths.spaces.leave);
      trackOperation({ action: 'space.leave', resource: 'space', result: 'success' });
    } catch (err) {
      trackFromError('space.leave', 'space', err);
      throw err;
    }
  },
  getMembers: (): Promise<MemberView[]> => client.get<MemberView[]>(apiPaths.spaces.members),
  getRole: (): Promise<SpaceRoleResp> => client.get<SpaceRoleResp>(apiPaths.spaces.role),
};

export type SpaceApi = typeof spaceApi;
